import { em } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  max-width: ${em(300)};
  height: ${em(250)};
  text-align: center;
  margin: 0 auto;
  padding-top: ${em(40)};
`
